import { initSimpleTooltips, calculateMinWidth } from "@plugins";
import jquery from "jquery";

const $ = jquery;
const tooltipOptions = {
    touch: true,
};
const catalogTopTagsContainers = document.querySelectorAll(
    ".js-catalog-top-tags-limited-width-init",
);

if (catalogTopTagsContainers) {
    for (const catalogTopTagsContainer of catalogTopTagsContainers) {
        if (window.mobileMedia) {
            limitCatalogTopTagsWrapperWidth(catalogTopTagsContainer);
        }
    }
}

function limitCatalogTopTagsWrapperWidth(tagsContainer) {
    const tagsWrap = tagsContainer.querySelector(".js-tags-wrap");

    if (!tagsWrap) {
        const error = "Нет обертки";
        console.error(tagsContainer, error);
    }

    const tags = tagsWrap.children;

    if (!tags) {
        const error = new Error("Нет тегов");
        console.error(tagsWrap, error);
    }

    let minTagsWrapperWidth = 0;
    const elementMarginRight = "8px";

    minTagsWrapperWidth = calculateMinWidth(tags, 0, tags.length, elementMarginRight);

    tagsWrap.style.minWidth = `${minTagsWrapperWidth}px`;
}

$(document).ajaxSuccess(() => {
    initSimpleTooltips(".js-catalog-top-btn", tooltipOptions);
});

window.addEventListener("load", initSimpleTooltips(".js-catalog-top-btn", tooltipOptions));
